//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import gql from 'graphql-tag'

export default {
  name: 'NewResponse',

  props: {
    ticket_id: null
  },

  data: function() {
    return {
      loading: false,
      savingResponse: false,
      response: {
        response_body: null,
        after_hours_billable: false,
        response_type: 'Public',
        time_spent: 0,
        attachments: []
      }
    }
  },

  methods: {
    async saveNewTicketResponse() {
      this.loading = true
      this.$emit('saving_response')
      this.savingResponse = true
      await this.$apollo
        .mutate({
          mutation: gql`
            mutation($input: CreateTicketResponseInput!) {
              createTicketResponse(input: $input) {
                id
                responses {
                  response_body
                  id
                  after_hours_billable
                  time_spent
                  response_type
                  system_response
                  creator {
                    id
                    first_name
                    last_name
                    full_name
                    admin
                  }
                  attachment {
                    id
                    file_name
                  }
                  ticket_has_file_attachment
                  created_at
                }
              }
            }
          `,
          variables: {
            input: {
              id: this.ticket_id,
              responses: {
                create: [
                  {
                    response_body: this.response.response_body,
                    author: parseInt(this.$store.getters.getUser.id),
                    //after_hours: this.response.after_hours_billable,
                    //time_spent: this.response.time_spent,
                    response_type: this.response.response_type
                  }
                ]
              }
            }
          }
        })
        .then(data => {
          this.$emit('response_saved', data.data.createTicketResponse.responses)
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
